import studiesReducer from './reducers';
export { default as studiesOperations } from './operations';
export { default as studiesTypes } from './types';
export default studiesReducer;
